export const DEFAULT_URI = '100';
